/* maeda-en® - 2026/06/22 - taste compare feature */

var STORAGE_KEY = 'maeda_en_compare';
var MAX_COMPARE = 3;
var COMPARE_PAGE = '/pages/taste-compare';

var selected = [];

function loadState() {
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (raw) selected = JSON.parse(raw) || [];
  } catch (e) {}
}

function saveState() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
  } catch (e) {}
}

function toggleCompare(handle) {
  var idx = selected.indexOf(handle);
  if (idx >= 0) {
    selected.splice(idx, 1);
  } else {
    if (selected.length >= MAX_COMPARE) {
      showToast('Max 3 products. Remove one to continue.');
      return;
    }
    selected.push(handle);
  }
  saveState();
  updateButtons();
  renderBar();
}

function updateButtons() {
  document.querySelectorAll('.maeda-compare-toggle').forEach(function(btn) {
    var isSelected = selected.indexOf(btn.dataset.handle) >= 0;
    btn.classList.toggle('is-selected', isSelected);
    var label = btn.querySelector('.maeda-compare-label');
    if (label) label.textContent = isSelected ? 'Selected' : 'Compare';
  });
}

function renderBar() {
  var bar = document.getElementById('maeda-compare-bar');
  var chips = document.getElementById('maeda-compare-chips');
  var goBtn = document.getElementById('maeda-compare-go');
  if (!bar) return;

  if (selected.length === 0) {
    bar.hidden = true;
    return;
  }

  bar.hidden = false;
  chips.innerHTML = selected.map(function(handle) {
    var btn = document.querySelector('.maeda-compare-toggle[data-handle="' + handle + '"]');
    var title = btn ? btn.dataset.title : handle;
    return '<span class="maeda-compare-bar__chip">' +
      '<span class="maeda-compare-bar__chip-name">' + title + '</span>' +
      '<button class="maeda-compare-bar__chip-remove" data-handle="' + handle + '" aria-label="Remove">&times;</button>' +
      '</span>';
  }).join('');

  chips.querySelectorAll('.maeda-compare-bar__chip-remove').forEach(function(btn) {
    btn.addEventListener('click', function() { toggleCompare(btn.dataset.handle); });
  });

  goBtn.textContent = 'Compare (' + selected.length + ')';
  goBtn.disabled = selected.length < 2;
}

/* maeda-en® - 2026/06/30 - shared clear logic, also called from the taste-compare page's own Clear Comparison button so the floating bar resets too */
function clearAll() {
  selected = [];
  saveState();
  updateButtons();
  renderBar();
}
window.maedaClearCompareBar = clearAll;

function showToast(msg) {
  var toast = document.getElementById('maeda-compare-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'maeda-compare-toast';
    toast.className = 'maeda-compare-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('is-visible');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(function() { toast.classList.remove('is-visible'); }, 2200);
}

function init() {
  loadState();
  updateButtons();
  renderBar();

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('.maeda-compare-toggle');
    if (toggle) { toggleCompare(toggle.dataset.handle); return; }

    if (e.target.id === 'maeda-compare-go') {
      if (selected.length >= 2) {
        window.location.href = COMPARE_PAGE + '?p=' + selected.join(',');
      }
      return;
    }

    if (e.target.id === 'maeda-compare-clear') {
      clearAll();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
